export default "<div class=\"main-content auth\">\r\n  <router-outlet></router-outlet>\r\n\r\n</div>\r\n"